export const AUTH_TOKEN_KEY_LOCAL_STORAGE = 'token'